"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles({
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial",
    },
    fullWidth: {
        width: "100%",
    },
    hide: {
        display: "none",
    },
});
var MonacoContainer = function (_a) {
    var width = _a.width, height = _a.height, isEditorReady = _a.isEditorReady, loading = _a.loading, reference = _a.reference;
    var classes = useStyles({});
    return (react_1.default.createElement("section", { className: classes.wrapper, style: { width: width, height: height } },
        react_1.default.createElement("div", { ref: reference, className: classes.fullWidth })));
};
exports.default = MonacoContainer;
